const veeValidateErrorsMixin = {
  methods: {
    doInsertVeeValidateErrors(errors, scope = '') {
      Object.keys(errors).forEach((error) => {
        this.errors.add({
          field: error,
          msg: errors[error][0],
          scope,
        });
      });
    },
    addServerErrors(errors) {
      if (!this.observer || typeof errors === 'undefined' || errors === null) {
        return;
      }

      this.observer.setErrors(errors);
    },
  },
};

export default veeValidateErrorsMixin;
